const QwLogo = ({ size = 40, className = "" }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    aria-label="Quick Wash logo"
  >
    <defs>
      <linearGradient id="qw-body" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#2563EB" />
        <stop offset="100%" stopColor="#1D4ED8" />
      </linearGradient>
      <linearGradient id="qw-drum" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#ECFDF5" />
        <stop offset="100%" stopColor="#D1FAE5" />
      </linearGradient>
    </defs>
    {/* body */}
    <rect x="6" y="4" width="52" height="56" rx="9" fill="url(#qw-body)" />
    {/* top strip */}
    <rect x="6" y="4" width="52" height="12" rx="9" fill="#1E3A8A" />
    <circle cx="16" cy="10" r="1.6" fill="#10B981" />
    <circle cx="22" cy="10" r="1.6" fill="#F97316" />
    <rect x="34" y="8.5" width="18" height="3" rx="1.5" fill="#93C5FD" />
    {/* drum outer ring */}
    <circle cx="32" cy="38" r="17" fill="#0F172A" opacity="0.15" />
    <circle cx="32" cy="38" r="16" fill="#F8FAFC" />
    <circle cx="32" cy="38" r="13" fill="url(#qw-drum)" stroke="#10B981" strokeWidth="1.6" />
    {/* QW letters */}
    <text
      x="32"
      y="43.5"
      textAnchor="middle"
      fontFamily="Poppins, sans-serif"
      fontWeight="800"
      fontSize="13"
      fill="#0F172A"
      letterSpacing="0.5"
    >
      QW
    </text>
    {/* bubble accents */}
    <circle cx="18" cy="30" r="2" fill="#10B981" opacity="0.85" />
    <circle cx="46" cy="48" r="1.6" fill="#F97316" opacity="0.9" />
  </svg>
);

export default QwLogo;
